import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslocoModule } from "@ngneat/transloco";
import { environment as env } from "../../../../../../../environments/environment.prod";
declare var ChartsEmbedSDK: any;
import { Workbook } from 'exceljs';

@Component({
  selector: "app-material",
  standalone: true,
  templateUrl: "./material-bp-modal.component.html",
  styleUrl: "./material-bp-modal.component.scss",
  imports: [
    TranslocoModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltip,
  ],
})
export class MaterialModalComponent {
  private chart: any;
  public filterForm: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<MaterialModalComponent>,
    private snckBar: MatSnackBar,
    private fb: FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Inicializar el formulario con valores vacíos
    this.filterForm = this.fb.group({
      startDate: [null],
    });
  }

  async ngOnInit() {
    const sdk = new ChartsEmbedSDK({
      baseUrl: env.mongoChart,
    });

    // Convertir pickerUpload_start/end a Date local
    const startDate = this.data.prefilter.pickerUpload_start
      ? new Date(this.data.prefilter.pickerUpload_start)
      : undefined;
    const endDate = this.data.prefilter.pickerUpload_end
      ? new Date(this.data.prefilter.pickerUpload_end)
      : undefined;

    const prefilter = {
      // Rango de fechas usando loadDateTime
      ...(this.data.prefilter.pickerUpload_start ||
      this.data.prefilter.pickerUpload_end
        ? {
            loadDateTime: {
              ...(startDate && { $gte: startDate }),
              ...(endDate && { $lt: endDate }),
            },
          }
        : {}),
    };

    this.chart = sdk.createChart({
      chartId: env.chartId,
      preFilter: prefilter,
      filter: { materialCodigo: this.data.element.code },
    });

    await this.chart
      .render(document.getElementById("chart")!)
      .then(() => {
        const iframe = document.querySelector(
          "#chart iframe"
        ) as HTMLIFrameElement;
        if (iframe) {
          iframe.style.backgroundColor = "#f9fafb"; //  bg-gray-50
          iframe.style.borderRadius = "0.375rem"; // rounded-md
        }
      })
      .catch((err) =>
        this.snckBar.open(err.error.message, "Cerrar", { duration: 5000 })
      );
  }

  async filterByMaterial() {
    if (!this.chart) return;

    const filtro: any = {};

    if (this.data.code) {
      filtro["materialCodigo"] = this.data.code;
    }
    await this.chart.setFilter(filtro);
  }

  public async exportChart() {
    try {
      // 1. Obtener datos del gráfico
      const chartData = await this.chart.getData();

      //  Verificar si hay datos para exportar
      if (!chartData.documents || chartData.documents.length === 0) {
        // this.snackBar.open('No hay datos para exportar', 'Cerrar', { duration: 3000 });
        return;
      }

      // 2. Crear workbook y worksheet
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Reporte");

      // 3. Definir el orden deseado de las columnas
      const headers = [
        chartData.fields.group, // Código Socio
        chartData.fields.group_series_0, // Nombre
        chartData.fields.group_series_1, // Código Material
        chartData.fields.group_series_2, // Material
        chartData.fields.value, // Cantidad UMB
        chartData.fields.group_series_3, // UMB
        chartData.fields.value_series_0, // Cantidad UMP
        chartData.fields.group_series_4, // UMP
      ];

      // 4. Agregar encabezados
      worksheet.addRow(headers);

      // 5. Agregar datos en el mismo orden
      chartData.documents.forEach((item) => {
        worksheet.addRow([
          item.group, // Código Socio
          item.group_series_0, // Nombre
          item.group_series_1, // Código Material
          item.group_series_2, // Material
          item.value, // Cantidad UMB
          item.group_series_3, // UMB
          item.value_series_0, // Cantidad UMP
          item.group_series_4, // UMP
        ]);
      });

      // 6. Formatear columnas
      worksheet.columns = [
        { header: chartData.fields.group, key: "codigo_socio", width: 15 },
        { header: chartData.fields.group_series_0, key: "nombre", width: 40 },
        {
          header: chartData.fields.group_series_1,
          key: "codigo_material",
          width: 20,
        },
        { header: chartData.fields.group_series_2, key: "material", width: 30 },
        { header: chartData.fields.group_series_3, key: "umb_desc", width: 15 },
        {
          header: chartData.fields.value,
          key: "cantidad_umb",
          width: 15,
          style: {
            numFmt: "#,##0.00",
            alignment: { horizontal: "right" },
          },
        },
        { header: chartData.fields.group_series_4, key: "ump_desc", width: 15 },
        {
          header: chartData.fields.value_series_0,
          key: "cantidad_ump",
          width: 15,
          style: {
            numFmt: "#,##0",
            alignment: { horizontal: "right" },
          },
        },
      ];

      // 7. Generar y descargar el archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Reporte_${new Date().toISOString().slice(0, 10)}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      this.snckBar.open("Error al exportar el reporte", "Cerrar", {
        duration: 3000,
      });
    }
  }
}